import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/es";
import { v4 } from "uuid";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("es");

export interface FertSlotRequestMessageItem {
  esUsted: boolean;
  texto: string;
  fechaHora: string;
  usuario: string;
}

interface Props {
  messages: FertSlotRequestMessageItem[];
}

export const FertSlotRequestMessagesTable = ({ messages }: Props) => {
  return (
    <Flex flexDir="column" gap="25px" flexShrink={0}>
      {Boolean(!messages?.length) && (
        <Flex>
          <Text fontWeight={600}>No hay mensajes para mostrar</Text>
        </Flex>
      )}

      {messages?.map((msg) => (
        <Flex
          key={v4()}
          flexDir="column"
          paddingX="24px"
          borderLeft={`4px solid ${
            msg?.esUsted ? AppColors.BLACK_TEXT_SECONDARY : AppColors.WHITE_BORDER_1
          }`}
        >
          <Text fontWeight={400}>{msg.texto}</Text>
          <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
            {dayjs
              .utc(msg.fechaHora)
              .tz("America/Argentina/Buenos_Aires")
              .format("DD/MM/YYYY - HH:mm")}{" "}
            - {msg.usuario}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
